import React, { useState, useEffect, useRef, useMemo } from 'react';
import { useParams, useNavigate } from 'react-router-dom'; // ✅ useNavigate added
import JoditEditor from "jodit-react";
import { ProtectAPi } from '../../../../../api/ProtectAPi';
import swal from 'sweetalert';
import BackButton from '../../../../tools/BackButton';
import { ServerUrl } from '../../../../../api/ServerUrl';

const FactoryInfo = () => {
    const { http } = ProtectAPi();
    const { id } = useParams();
    const navigate = useNavigate(); // ✅ for redirecting
    const editor = useRef(null);
    const [loader, setLoader] = useState('off');
    const [url, setUrl] = useState('');
    const [title, setTitle] = useState('');
    const [isVideoOrImage, setIsVideoOrImage] = useState('');
    const [description, setDescription] = useState('');
    const [titleError, setTitleError] = useState('');
    const [descriptionError, setDescriptionError] = useState('');
    const [layoutImage, setLayoutImage] = useState(null);
    const [layoutImageError, setLayoutImageError] = useState('');
    const [imagePreview, setImagePreview] = useState('');
    const [altText, setAltText] = useState('');
    const [altTextError, setAltTextError] = useState('');

    useEffect(() => {
        http.get(`/get-our-factory-info-edit/${id}`)
            .then(res => {
                setUrl(res.data.info_url);
                setTitle(res.data.info_title);
                setDescription(res.data.description);
                setAltText(res.data.alt || '');
                setIsVideoOrImage(res.data.info_type === 0 ? '0' : '1');
                const layoutImage = res.data.image;
                if (layoutImage) {
                    const layoutImageShow = `${ServerUrl}/backend/img/factory/${layoutImage}`;
                    setImagePreview(layoutImageShow);
                }
            })
            .catch(error => {
                console.error('Error fetching layout:', error);
            });
    }, []);

    const submitForm = () => {
        setLoader('on');
        setTitleError('');
        setDescriptionError('');
        setAltTextError('');

        const formData = new FormData();
        formData.append('info_url', url);
        formData.append('info_title', title);
        formData.append('description', description);
        formData.append('image', layoutImage);
        formData.append('alt', altText);
        formData.append('info_type', isVideoOrImage);

        http.post(`/update-our-factory-info/${id}`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            }
        }).then(res => {
            if (res.data.status === '422') {
                const errors = res.data.error;
                setLoader('off');
                setTitleError(errors.info_title || '');
                setDescriptionError(errors.description || '');
                setAltTextError(errors.alt || '');
            } else {
                setLoader('off');
                swal('Success', res.data.msg, 'success');
                navigate('/admin/pages/our-factory-info-list'); // ✅ redirect to list page
            }
        }).catch(error => {
            console.error('Error:', error);
        });
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        if (name === 'layoutTitle') {
            setTitle(value);
        } else if (name === 'url') {
            setUrl(value);
        }
    };

    const handleImageChange = (e) => {
        const selectedImage = e.target.files[0];
        setLayoutImage(selectedImage);
        const previewURL = URL.createObjectURL(selectedImage);
        setImagePreview(previewURL);
    };

    const editorConfig = useMemo(() => ({
        readonly: false,
        placeholder: 'Start typing...',
        uploader: {
            insertImageAsBase64URI: true
        }
    }), []);

    return (
        <div className="main-content">
            <section className="section">
                <div className="section-body">
                    <div className="row">
                        <div className="col-12">
                            <div className="card card-primary">
                                <div className="card-body">
                                    <div className="d-flex justify-content-between">
                                        <h5>Factory Information</h5>
                                        <BackButton />
                                    </div>
                                    <div className="card-body pb-0">
                                        <div className="row">
                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label>Title</label>
                                                    <input type="text" name="layoutTitle" value={title} className="form-control" placeholder='Title' onChange={handleInputChange} />
                                                    <span className='text-danger'>{titleError}</span>
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label>Home Show</label>
                                                    <select className="form-control" value={isVideoOrImage} onChange={e => setIsVideoOrImage(e.target.value)}>
                                                        <option value="">Select</option>
                                                        <option value="1">Image</option>
                                                        <option value="0">YouTube Video</option>
                                                    </select>
                                                </div>
                                            </div>

                                            {isVideoOrImage === '0' && (
                                                <div className="col-md-6">
                                                    <div className="form-group">
                                                        <label>YouTube URL</label>
                                                        <input type="text" name="url" value={url} className="form-control" placeholder='YouTube Embed URL' onChange={handleInputChange} />
                                                    </div>
                                                </div>
                                            )}

                                            {isVideoOrImage === '1' && (
                                                <>
                                                    <div className="col-md-6">
                                                        <label>Image</label>
                                                        <div className="logo-box mt-3">
                                                            <div className="logo">
                                                                <label htmlFor="layoutImage">
                                                                    <div className="image-box border dottet p-2 rounded">
                                                                        {imagePreview ? (
                                                                            <img src={imagePreview} className='img-fluid' alt="Preview" />
                                                                        ) : (
                                                                            <img src="https://w7.pngwing.com/pngs/159/705/png-transparent-computer-computer-trademark-computer-logo.png" className='img-fluid' alt="Default" />
                                                                        )}
                                                                    </div>
                                                                    <input type="file" id="layoutImage" className="form-control d-none" onChange={handleImageChange} />
                                                                    <span className='btn btn-primary mt-1 w-100'>Upload Image</span>
                                                                    <span className='text-danger'>{layoutImageError}</span>
                                                                </label>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="col-md-6">
                                                        <div className="form-group">
                                                            <label>Image Alt Text</label>
                                                            <input type="text" className="form-control" value={altText} onChange={e => setAltText(e.target.value)} placeholder="Enter alt text for image" />
                                                            <span className='text-danger'>{altTextError}</span>
                                                        </div>
                                                    </div>
                                                </>
                                            )}

                                            <div className="col-md-12 mt-4">
                                                <label>Description</label>
                                                <JoditEditor
                                                    ref={editor}
                                                    value={description}
                                                    config={{
                                                        readonly: false,
                                                        height: 400,
                                                        placeholder: 'Start typing...',
                                                        uploader: {
                                                            insertImageAsBase64URI: true
                                                        }
                                                    }}
                                                    tabIndex={1}
                                                    onBlur={newContent => setDescription(newContent)}
                                                    onChange={() => { }}
                                                />
                                                <span className='text-danger'>{descriptionError}</span>
                                            </div>

                                            <div className="col-md-12 mt-5 mb-4">
                                                {loader === 'off' ?
                                                    <button type="submit" onClick={submitForm} className="btn btn-lg btn-primary">Update</button> :
                                                    <div className="spinner-border text-dark" role="status"></div>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default FactoryInfo;
